import { Link as RouterLink, useNavigate, useLocation } from 'react-router-dom'
import React, { useRef, useState, useEffect, useContext } from 'react'
import { Icon } from '@iconify/react'
import homeFill from '@iconify/icons-eva/home-fill'
import personFill from '@iconify/icons-eva/person-fill'
import settings2Fill from '@iconify/icons-eva/settings-2-fill'
import QrReader from 'react-qr-reader'
import { alpha } from '@material-ui/core/styles'
import QRCode from "qrcode.react"
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import jwt_decode from 'jwt-decode'
import {
  Button,
  Box,
  Divider,
  MenuItem,
  Typography,
  Avatar,
  IconButton,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Grid,
  Container,
  FormControlLabel,
  Checkbox,
  Modal,
  Backdrop,
  Fade,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Toolbar,
  Paper,
  TableContainer,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  ListItemButton,
  AppBar,
  FormControl,
  InputLabel,
  Select,
  Alert,
  OutlinedInput,
  Autocomplete,
  Chip,
  Switch
} from '@material-ui/core'
import CloseIcon from '@mui/icons-material/Close';
import { addDays } from 'date-fns'
import MenuPopover from '../../components/MenuPopover'
/*import DatePicker from "react-datepicker";*/
import "react-datepicker/dist/react-datepicker.css"
import storage from 'utils/storage'

import { Formik, useField } from 'formik'
import * as yup from 'yup'
import dayjs from 'dayjs';
import discord_api from 'utils/api/discord'
import { useSnackbar } from 'notistack5'
import Bugsnag from '@bugsnag/js'
import useUser from 'utils/api/users'
import authUser from 'utils/api/auth'
import Clock from 'react-live-clock'
import { SocketContext } from 'utils/context/socket'
import { BreakOut, BreakIn, TimeIn, TimeOut, Completed, Loading } from 'components/timeButton'
import user_api from 'utils/api/users'
import Page from '../../components/Page'
import '../../_style.css'

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { makeStyles } from '@material-ui/styles'
import { CSVLink } from 'react-csv'
import GetAppIcon from '@material-ui/icons/GetApp'
import HistoryIcon from '@mui/icons-material/History';
import DateRangeIcon from '@mui/icons-material/DateRange';
import { WeeklySummary } from 'components/timekeepingHistory';
import { AllShift } from 'components/timekeepingHistory';
import MenuIcon from '@mui/icons-material/Menu';
import Numpad from 'components/authentication/login/Numpad'
import FourDigitDisplay from 'components/authentication/login/FourDigitDisplay'
import { Visibility, VisibilityOff } from '@mui/icons-material'
import { set } from 'lodash'
import OTPInput from 'react-otp-input'
import AccountChangeMPIN from 'components/account/AccountChangeMPIN';
import { useAuth } from 'components/SessionAuth'
import { logSuccessAction, ACTION_CATEGORIES } from 'utils/actionLogger'

// Add import for historyEvents
// import { historyEvents } from '../../pages/EmployeeDashboard';

// Add import for the new MyHistoryDialog component
import MyHistoryDialog from '../../components/MyHistoryDialog';

const useStyles = makeStyles({
  customWidth: {
    maxWidth: "none",
    height: "500px"
  },
  customWidthHistory: {
    maxWidth: "none",
    height: "80%"
  }
})

// const MENU_OPTIONS = [
//   {
//     label: 'Home',
//     icon: homeFill,
//     linkTo: '/',
//   },
//   {
//     label: 'Profile',
//     icon: personFill,
//     linkTo: '/stores/profile',
//   },
//   {
//     label: 'Settings',
//     icon: settings2Fill,
//     linkTo: '#',
//   },
// ]

const validationSchema = yup.object({
  company: yup.string().max(100, 'Too long').required(),
})

const CustomTextField = ({ type, label, placeholder, InputProps, ...props }) => {
  const [field, meta] = useField(props)
  const errorText = meta.error && meta.touched ? meta.error : ''
  return (
    <TextField
      label={label}
      type={type}
      variant="standard"
      fullWidth
      margin="dense"
      required
      placeholder={placeholder}
      {...field}
      helperText={errorText}
      error={!!errorText}
      InputProps={InputProps}
    />
  )
}
// ----------------------------------------------------------------------
const moment = require('moment-timezone')
moment().tz('Asia/Manila').format()
const current_date = `${moment().tz('Asia/Manila').toISOString(true)}`

const AccountPopover = ({ user, onNavigate, onOpenWorkmateTimein }) => {
  const classes = useStyles()
  const { logout } = useAuth()
  let today = new Date(current_date)
  const anchorRef = useRef(null)
  const navigate = useNavigate()
  const locationPage = useLocation() // Add useLocation hook
  const isEmployeeDashboard = locationPage.pathname === '/dashboard/app' || locationPage.pathname === '/dashboard/employee/app' || locationPage.pathname === '/dashboard'
  const [open, setOpen] = useState(false)
  const [checklistStatus, setChecklistStatus] = useState(true)
  const [openSchedule, setOpenSchedule] = useState(false)
  const [openPayslip, setOpenPayslip] = useState(false)
  const [openThirteenMonthPayslip, setOpenThirteenMonthPayslip] = useState(false)
  const [openPayslipV2, setOpenPayslipV2] = useState(false)
  const [id, setId] = useState('')
  const [name, setName] = useState('')
  const [myCompany, setMyCompany] = useState(false)
  const [myDocuments, setMyDocuments] = useState(false)
  const [myTraining, setMyTraining] = useState(false)
  const [checklists, setChecklists] = useState(["I testify that I am in front of the TS and management representative upon signing in. Also, I signify that I have:","Complete uniform.","Name plate.","Proper grooming.","Vaccination card."])
/*  const [checklist1, setChecklist1] = useState("Complete uniform.")
  const [checklist2, setChecklist2] = useState("Name plate.")
  const [checklist3, setChecklist3] = useState("Proper grooming.")
  const [checklist4, setChecklist4] = useState("Vaccination card.")*/
  const [openQR, setOpenQR] = useState(false)
  const [openChecklist, setOpenChecklist] = useState(false)
  const [openEdit, setOpenEdit] = useState(false)
  const [value, setValue] = useState(null)
  const [validated, setValidated] = useState(false)
  const { enqueueSnackbar } = useSnackbar()
  const [userState, setUser] = useState(user)
  const [currentDate, setCurrentDate] = useState(null)
  const [isLoading, setLoading] = useState(false)
  const [openHistory, setOpenHistory] = useState(false)
  const [openActiveUsers, setOpenActiveUsers] = useState(false)
  const [activeUserLoading, setActiveUserLoading] = useState(false)
  const socket = useContext(SocketContext)
  const [status, setStatus] = useState(null)
  const [link, setLink] = useState()
  const [qrUser, setQrUser] = useState({})
  const [users, setUsers] = useState([])
  const [userGetSchedule, setUserGetSchedule] = useState([])
  const [payrolls, setPayrolls] = useState([])
  const [activeUsers, setActiveUsers] = useState([])
  const [startDate, setStartDate] = useState(new Date());
  const [scheduleDate, setScheduleDate] = useState(new Date());
  const [selectedMonth, setSelectedMonth] = useState('');
  const [selectedPayroll, setSelectedPayroll] = useState();
  const [selectedPayrollV2, setSelectedPayrollV2] = useState();
  const [selectedCompany, setSelectedCompany] = useState('');
  const [selectedMonthIndex, setselectedMonthIndex] = useState(0);
  const [openVideoGuides, setOpenVideoGuides] = useState(false)
  const [videoFetched, setVedioFetched] = useState(false)
  const [openUpdateEmail, setOpenUpdateEmail] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const [newEmail, setNewEmail] = useState(userState.email)
  const [videoList, setVideoList] = useState()
  const [urlPayslip, setUrlPayslip] = useState('')
  const [urlPayslipV2, setUrlPayslipV2] = useState('')
  const [urlThirteenthMonth, setUrlThirteenthMonth] = useState('')
  const [authCheck, setAuthCheck] = useState(false)
  const [authCheckEditCompany, setAuthCheckEditCompany] = useState(true)
  const [authCheckPass, setAuthCheckPass] = useState('');
  const [selectionType, setSelectionType] = useState('');
  const [groupList, setGroupList] = useState([]);
  const [storeList, setStoreList] = useState([]);
  const [storeListForExtraction, setStoreListForExtraction] = useState([]);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [selectedStores, setSelectedStores] = useState([]);
  const [userList, setUserList] = useState([]);
  const [selectedUser, setSelectedUser] = useState('');
  const [holidayName, setHolidayName] = useState('');
  const [holidayType, setHolidayType] = useState('');
  const [holidayDate, setHolidayDate] = useState(new Date().toISOString().split('T')[0]);
  const [openSetHoliday, setOpenSetHoliday] = useState(false);
  const [holidayDialogLoading, setHolidayDialogLoading] = useState(false);
  const [applyToWholeGroups, setApplyToWholeGroups] = useState(true);
  const [authCheckPassCompany, setAuthCheckPassCompany] = useState('');
  const [isPress, setIsPress] = useState({
    history: false,
    schedule: false,
    payslip: false,
    video: false,
    settings: false
  })
  const [location, setLocation] = useState({
    latitude: 0,
    longitude: 0,
  })
  const months = [
    'January', 'February', 'March', 'April',
    'May', 'June', 'July', 'August',
    'September', 'October', 'November', 'December'
  ];
  const company = [
    '7star', 'Syzygy', 'Jasem', 'Admin'
  ];
  const [summaryPage, setSummaryPage] = useState(true)
  const [allShiftPage, setAllShiftPage] = useState(false)
  const checkAndroid = /Android/.test(navigator.userAgent)
  const checkIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent)
  const checkMac = /Macintosh/.test(navigator.userAgent)

  const handleMonthChange = (event) => {
    setSelectedMonth(event.target.value);
    setselectedMonthIndex(event.target.value + 1)
    setActiveUsers([])
  };
  const handlePayrollChange = (event) => {
    setSelectedPayroll(event.target.value);
  };

  const handlePayrollChangeV2 = (event) => {
    console.log(event.target.value)
    setSelectedPayrollV2(event.target.value);
  };

  const handleCompanyChange = (event) => {
    setSelectedCompany(event.target.value);
    setActiveUsers([])
  };
  const handleExtractUsers = async () => {
    setActiveUserLoading(true)
    let formattedCompany = ""
    if (selectedMonthIndex === 0) {
      alert("Please input month")
    }
    else if (!selectedCompany) {
      alert("Please input company")
    }
    else {
      if (selectedCompany === "7star") {
        formattedCompany = "7-star"
      }
      else if (selectedCompany === "Syzygy") {
        formattedCompany = "syzygy"
      }
      else if (selectedCompany === "Admin") {
        formattedCompany = "Inhouse"
      }
      else {
        formattedCompany = "jasem"
      }
      const data = {
        company: formattedCompany,
        month: selectedMonthIndex
      }
      const result = await useUser.get_active_users(data)
      if (result.data.msg) {
        alert(result.data.msg)
        setActiveUserLoading(false)
      }
      else {
        const uniqueArray = result.data.filter(
          (item, index, self) => self.findIndex((i) => i.name === item.name) === index
        );
        setActiveUsers(uniqueArray)
      }

    }
    setActiveUserLoading(false)
  };

  useEffect(() => {
    if(selectedPayroll){
      handleGeneratePayslip()
    }

    if(selectedPayrollV2){
      handleGeneratePayslipV2()
    }
  }, [selectedPayroll, selectedPayrollV2])

  const getCsvData = () => {

    const csvData = []
    csvData.push([`Company: `, `${selectedCompany}`])
    csvData.push([`Month: `, `${months[selectedMonth]}`])
    csvData.push(['', '', '', '', '', ''])
    csvData.push(['', '', '', '', '', ''])
    csvData.push(['Store', 'Employee'])
    activeUsers.map(user => {
      csvData.push([user.store, user.name])
    })
    return csvData
  }
  const load = async () => {
    const token = await storage.getToken()
    if (!token) {
      await storage.remove()
      return navigate('/login')
    }
    const inuser = await user_api.get_user(jwt_decode(token)['id'])
    if (!inuser.ok) {
      Bugsnag.notify(inuser)
      await storage.remove()
      return navigate('/login')
    }

    await storage.storeUser(inuser.data)
    const local_user = await storage.getUser()
/*    if (!local_user) return enqueueSnackbar('Unable to proceed, Kindly Re-log again', { variant: 'warning' })*/
    const userState = JSON.parse(local_user)
    setUser(userState)
    const features = await user_api.get_features({ store: userState.company })
    if (features.data.length > 0) {
      features.data.forEach(feature => {
        feature.features.forEach(data => {
          if (data.feature === "My Documents") {
             setMyDocuments(true)
           }
           if (data.feature === "My Company") {
             setMyCompany(true)
           }
           if (data.feature === "Training And Development") {
             setMyTraining(true)
           }
        })
      })
    }
    if(inuser.data.role >= 3) {
      const getCompany = await user_api.get_group_store(inuser.data._id);
      setStoreListForExtraction(getCompany.data.report.store)
    }
  }
  
  useEffect(() => {
    load()
  }, [])

  const handleClickOpenEdit = () => {
    setOpenEdit(true)
  }

  const handleCloseEdit = () => {
    setValidated(false)
    setOpenEdit(false)
    setAuthCheckPassCompany('')
    setAuthCheckEditCompany(true)
  }

  const handleClickOpenUpdateEmail = () => {
    setOpenUpdateEmail(true)
  }

  const handleCloseUpdateEmail = () => {
    setOpenUpdateEmail(false)
    setAuthCheck(false)
    setAuthCheckPass('')
  }

  const handleOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setValidated(false)
    setOpen(false)
  }
  const handleOpenChecklist = async () => {
    const data = {
      "store": user.company
    }
    const result = await user_api.get_checklist(data)
    if(result.data.data !== "No records found") {
      if(result.data.data[0].toggle) {
        setChecklistStatus(true)
      }
      else {
        setChecklistStatus(false)
      }
      setChecklists(result.data.data[0].checklists)
    }
    else {
      setChecklists(["I testify that I am in front of the TS and management representative upon signing in. Also, I signify that I have:","Complete uniform.","Name plate.","Proper grooming.","Vaccination card."])
    }
    setOpenChecklist(true)
  }
  const handleCloseChecklist = () => {
    setOpenChecklist(false)
  }
  const handleSignOut = async (e) => {
    e.preventDefault()
    await logout()
  }

  const handleOpenWorkmateTimein = async () => {
    console.log("open")
    if (typeof onOpenWorkmateTimein === 'function') {
      onOpenWorkmateTimein();
    } else {
      console.log("No onOpenWorkmateTimein function available");
    }
  }

  const handleSubmitChecklist = async () => {
    setActiveUsers(true)
    if(!checklists[0] || !checklists[1] || !checklists[2] || !checklists[3]) {
      alert("Please fill up all the fields")
    }
    else {
      const data = {
        "store": user.company,
        "checklists": checklists,
        "status": checklistStatus
      }
      const result = await user_api.post_checklist(data)
      if (result.data.msg === "Success") {
        // Log successful checklist update
        logSuccessAction({
          user: userState._id,
          company: userState.company,
          userDisplay: {
            name: userState.displayName,
            email: userState.email
          },
          role: userState.role,
          action: 'Update Store Checklist',
          category: ACTION_CATEGORIES.STORE_CONFIGURATION,
          details: `Successfully updated store checklist for "${user.company}". Status: ${checklistStatus ? 'Enabled' : 'Disabled'}. Items: ${checklists.length} checklist items configured.`
        });
        
        alert("Checklist save")
        setOpenChecklist(false)
      }
      else {
        alert(result.data.msg)
      }
      setActiveUsers(false)  
    }
    
  }

  const handleError = (err) => {
    console.error(err)
  }

  const handleGeneratePayslip = async () => {
    setActiveUserLoading(true)
    if (!selectedPayroll) {
      alert("Please input cutoff date")
      setActiveUserLoading(false)
    }
    else {
      setUrlPayslip(`https://payroll-live.sparkletimekeeping.com/payroll/public/payslip-api/${userState._id}/${selectedPayroll}`)
      setActiveUserLoading(false)  
    }

  }  

  const handleGeneratePayslipV2 = async () => {
    setActiveUserLoading(true)
    if (!selectedPayrollV2) {
      alert("Please input cutoff date")
      setActiveUserLoading(false)
    }
    else {
      setUrlPayslipV2(`https://payroll.sparkletimekeeping.com/payslip/${selectedPayrollV2}/${userState._id}`)
      setActiveUserLoading(false)  
    }

  }

  const saveGeneratedPayslip = async () => {
    if(!urlPayslip){
      alert("Please select a payslip")
      return
    }
    const link = document.createElement('a');
    link.href = urlPayslip;
    link.setAttribute('download', `payslip-${selectedPayroll}.pdf`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const handleStatus = async (_id) => {
    if (!_id) {
      setLoading(false)
      return navigate('/login')
    }

    setLoading(true)
    await geolocation()
    const result = await user_api.get_user_status(_id)

    if (!result.ok) {
      setLoading(false)
      Bugsnag.notify(result)
      setStatus(null)
    }

    if (!result || !result.data) {
      setStatus(null)
      return setLoading(false)
    }

    if (!result.data) return setLoading(false)
    let { status, date } = result.data[0] // get the last data

    let record_date = new Date(date)

    // if (record_date.getDate() === today.getDate() && record_date.getUTCMonth() + 1 === today.getUTCMonth() + 1) {
    setStatus(status)
    setCurrentDate(date)
    // } else {
    if (record_date.getDate() !== today.getDate() && status === 'time-out') {
      setStatus(null)
      setLoading(false)
      return
    }
    // }

    switch (status) {
      case 'time-in':
        setStatus('Time in')
        break
      case 'time-out':
        setStatus('Time out')
        break
      case 'break-in':
        setStatus('Break in')
        break
      case 'break-out':
        setStatus('Break out')
        break
      default:
        setStatus(null)
        break
    }

    setLoading(false)
  }

  const ButtonMemo = React.memo(ButtonContainerMemo)

  function ButtonContainerMemo() {
    return <RenderButtonStatus />
  }

  function handleCheckboxChange(e) {
    setValidated(e.target.checked)
  }

  const geolocation = async () => {
    await navigator.geolocation.watchPosition(function (position) {
      setLocation({
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
      })
    })

    if (!location) return false
    return location
  }

  const handleUpdateStatus = async (status) => {
    try {
      setLoading(true)
      if (!status) return setLoading(false)
      await geolocation()

      if (!location.latitude && !location.longitude) return setLoading(false)
      let formatStatus = status.replace(' ', '-').toLowerCase()
      let previous = null
      let dataDate = new Date(currentDate)
      if (dataDate.getDate() !== today.getDate() || status !== 'time-in') {
        previous = currentDate
      }
      let workmate = user.displayName
      const result = await user_api.post_user_workmate_status(formatStatus, location, value, previous, workmate)
      if (!result.ok) {
        setLoading(false)
        Bugsnag.notify(result)
        return enqueueSnackbar(result.data.msg, { variant: 'error' })
      }

      switch (result.data.status) {
        case 'time-in':
          setStatus('Time out')
          break
        case 'time-out':
          setStatus('Time in')
          break
        case 'break-in':
          setStatus('Break out')
          break
        case 'break-out':
          setStatus('Break in')
          break
        default:
          break
      }

      socket.emit('update_status', status)
      enqueueSnackbar(`${status} Success`, { variant: 'success' })
      setLoading(false)
      handleStatus(value)
    } catch (error) {
      console.log(error)
    }
  }

  const RenderButtonStatus = () => {
    const cur_status = status

    switch (cur_status) {
      case null:
        return <TimeIn request={handleUpdateStatus} />
      case 'Time in':
        return (
          <>
            <TimeOut request={handleUpdateStatus} width="215px" current_status={cur_status} />
            <BreakIn request={handleUpdateStatus} width="215px" current_status={cur_status} />
            <span> for {` ${new Date(currentDate).toDateString()} `}</span>
          </>
        )
      case 'Break in':
        return (
          <>
            <BreakOut request={handleUpdateStatus} width="215px" current_status={cur_status} />
            <TimeOut request={handleUpdateStatus} width="215px" current_status={cur_status} />
            <span> for {` ${new Date(currentDate).toDateString()} `}</span>
          </>
        )
      case 'Break out':
        return (
          <>
            <TimeOut request={handleUpdateStatus} width="215px" current_status={cur_status} />
            <BreakIn request={handleUpdateStatus} width="215px" current_status={cur_status} />
            <span> for {` ${new Date(currentDate).toDateString()} `}</span>
          </>
        )
      case 'Time out':
        return (
          <>
            <Completed currentDate={currentDate} />
            <button onClick={() => setStatus(null)}>Ok</button>
          </>
        )
      default:
        return <Loading />
    }
  }

  const handleGenerateQR = (e) => {
    setOpenQR(true);
    setId(user._id);
    setName(user.displayName);
  }

  const handleCloseQR = () => setOpenQR(false);

  const downloadQRCode = () => {
    // Generate download with use canvas and stream
    const canvas = document.getElementById("qr-gen");
    const pngUrl = canvas.toDataURL("image/png");
    let downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = `${name}.png`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  const handleOpenHolidayDialog = async () => {
    // Fetch groups and stores data before opening the dialog
    setHolidayDialogLoading(true);
    try {
      await fetchGroupOrStoreList("both");
      setOpenSetHoliday(true);
    } catch (error) {
      console.error("Error fetching groups and stores:", error);
      alert("Failed to load groups and stores. Please try again.");
    } finally {
      setHolidayDialogLoading(false);
    }
  }

  const fetchGroupOrStoreList = async (type) => {
    const groups = await user_api.get_groups();
    const groupListData = groups.data.groups;
    setGroupList(groupListData);

    if (type === "group" || type === "both") {
      // For group selection, we don't need to fetch stores
      return;
    }

    // For store selection, fetch stores from the first group as default
    if (groupListData.length > 0) {
      const groupId = groupListData[0].id;
      const stores = await user_api.get_group_store(groupId);

      if (stores.data.report) {
        setStoreList(stores.data.report.store);
      }
    }
  };

  const handleGroupChange = async (event, newValue) => {
    setSelectedGroups(newValue);
    // Fetch stores for all selected groups
    if (newValue.length > 0) {
      const storePromises = newValue.map(group =>
        user_api.get_group_store(group.id)
      );
      const storeResults = await Promise.all(storePromises);
      const allStores = storeResults.flatMap(result =>
        result.data.report?.store || []
      );
      // Remove duplicates
      const uniqueStores = [...new Set(allStores)];
      setStoreList(uniqueStores);
    } else {
      setStoreList([]);
    }
  };

  const getSelectedGroupIds = () => {
    return selectedGroups.map(group => group.id);
  };

  const fetchStoresByGroup = async (groupId) => {
    const stores = await user_api.get_group_store(groupId);

    if (stores.data.report?.store?.length > 0) {
      const storeList = stores.data.report.store;
      setStoreList(storeList);
    } else {
      setStoreList([]);
    }
  };

  const handleSaveHoliday = async () => {
    if (!holidayName || !holidayDate || !holidayType) {
      alert("Please fill in all required fields");
      return;
    }

    if (selectedGroups.length === 0 && selectedStores.length === 0) {
      alert("Please select at least one group or store");
      return;
    }

    if (!applyToWholeGroups && selectedStores.length === 0) {
      alert("Please select at least one store when applying to specific stores");
      return;
    }

    try {
      const holidayData = {
        holiday: holidayName,
        date: holidayDate,
        type: holidayType,
        group: selectedGroups.map(group => group.companyName),
        store: selectedStores,
        applyToWholeGroups: applyToWholeGroups,
      };

      const response = await user_api.post_holiday(holidayData);

      if (response.status === 200) {
        // Log successful holiday creation/update
        const targets = [`Groups: ${selectedGroups.map(g => g.companyName).join(', ')}`];

        if (applyToWholeGroups) {
          targets.push('all stores in selected groups');
        } else {
          targets.push(`specific stores: ${selectedStores.join(', ')}`);
        }

        logSuccessAction({
          user: userState._id,
          company: userState.company,
          userDisplay: {
            name: userState.displayName,
            email: userState.email
          },
          role: userState.role,
          action: 'Set Holiday',
          category: ACTION_CATEGORIES.HOLIDAY_MANAGEMENT,
          details: `Successfully set holiday "${holidayName}" (${holidayType}) for ${moment(holidayDate).format('MMMM DD, YYYY')}. Applied to: ${targets.join(' - ')}.`
        });

        // Reset form
        setSelectionType('')
        setGroupList([])
        setStoreList([])
        setSelectedGroups([])
        setSelectedStores([])
        setHolidayName('')
        setHolidayType('')
        setHolidayDate(new Date().toISOString().split('T')[0])
        setApplyToWholeGroups(true)

        alert("Holiday saved or updated successfully")
        setOpenSetHoliday(false)
      } else {
        alert("Something went wrong please try again!")
      }
    } catch (error) {
      console.error("Error saving holiday:", error);
      alert("Something went wrong please try again!")
    }
  }
/*  const handleUpdateLocation = async () => {
    await geolocation()
    if (location.longitude !== 0 || location.latitude !== 0) {
      const data = {
        long: location.longitude,
        lat: location.latitude
      }
      const result = await user_api.patch_user_location(user._id, data);
      if (result.status === 200) {
        alert("Location update successful");
      }
    } else {
      alert("Please turn on your location");
    }
  }*/

  const renderTime = (_time) => {
    let _date = new Date(_time)
    var hours = _date.getHours()
    var minutes = _date.getMinutes()
    var ampm = hours >= 12 ? 'pm' : 'am'
    hours = hours % 12
    hours = hours ? hours : 12 // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes
    var strTime = hours + ':' + minutes + ' ' + ampm
    return strTime
  }

  const filterByStatus = (_data, type) => {
    let _d = _data.filter((_d) => (_d.status === type ? _d : ''))
    if (_d.length > 0) {
      _d = _d[0]
    }
    if (_d) {
      if (typeof (_d.time) === "string") {
        return {
          time: _d.time === undefined ? 'n/a' : _d.time,
          location: _d.address === undefined ? 'n/a' : _d.address,
          workmate: _d.workmate === undefined ? '' : 'Workmate( ' + _d.workmate + ' )'
        }
      }
      else {
        return {
          time: _d.time === undefined ? 'n/a' : renderTime(_d.time),
          location: _d.address === undefined ? 'n/a' : _d.address,
          workmate: _d.workmate === undefined ? '' : 'Workmate( ' + _d.workmate + ' )'
        }
      }
    } else {
      return '-'
    }
  }

  // Replace the handleOpenHistory function with a simpler version
  const handleOpenHistory = () => {
    setOpenHistory(true);
  };

  // Replace the handleCloseHistory function with a simpler version
  const handleCloseHistory = () => {
    setOpenHistory(false);
    setIsPress({
      history: false,
      schedule: false,
      payslip: false,
      video: false,
      settings: false
    });
  };

  const handleOpenActiveUsers = async () => {
    if (userState._id === undefined) {
      load()
      alert("Something went wrong please try again later")
    }
    else {
      const result = await user_api.get_limited_users(userState._id)
      setUsers(result.data)
      setOpenActiveUsers(true)
    }

  }

  const handleOpenVideoGuides = async () => {
    setOpenVideoGuides(true)
    setIsPress({
      history: false,
      schedule: false,
      payslip: false,
      video: false,
      settings: false
    })
    const company = JSON.parse(await storage.getUser()).company
    // setVedioFetched(true)
    // setVideoList(videoData)

    const getVedioResult = await user_api.get_videos_tutorial(company)
    if(getVedioResult.status === 200){
      setVideoList(getVedioResult.data.body)
      setVedioFetched(true)
    }
  }

  const handleViewYoutube = (viewId) =>{
    window.open(`https://www.youtube.com/watch?v=${viewId}`)
  }
  const handleCloseVideoGuides = () =>{
    setOpenVideoGuides(false)
  }

  const handleOpenSettings = () => {
    window.alert("Under development")
    setIsPress({
      history: false,
      schedule: false,
      payslip: false,
      video: false,
      settings: false
    })
  }

  const handleCloseActiveUsers = async () => {
    setOpenActiveUsers(false)
    setActiveUsers([])
  }
  const handleOpenPayslip = async () => {
    let payroll = []
    if (userState._id === undefined) {
      load()
      alert("Something went wrong please try again later")
    }
    else {
      setLoading(true)
      setPayslipLoading(true)
      const user = await user_api.get_user(userState._id)
      alert("Getting payslip data please wait")
      const data = {
        id: user.data._id,
        store: user.data.company
      }
      const result = await user_api.get_payslip_info(data)
      if (result.data.record.data.length > 0) {
        result.data.record.data.map(data => {
          payroll.push({ "id": data.id, "from": data.payroll_from, "to": data.payroll_to })
        })
        setPayrolls(payroll)
        setOpenPayslip(true)
      }
      else {
        setPayrolls([])
        setOpenPayslip(true)
      }
      setLoading(false)
      setPayslipLoading(false)

    }

  }

  const handleOpenPayslipV2 = async () => {
    let payroll = []
    if (userState._id === undefined) {
      load()
      alert("Something went wrong please try again later")
    }
    else {
      setLoading(true)
      setPayslipLoading(true)
      const data = {
        store: userState.company,
        employeeId: userState._id 
      }
      const payrollResult = await user_api.get_payslip_v3(data)
      alert("Getting payslip data please wait")
      if (payrollResult.data.data.length > 0) {
        payrollResult.data.data.map(data => {
          const formattedDateFrom = new Date(data.payroll_from).toISOString().split("T")[0];
          const formattedDateTo = new Date(data.payroll_to).toISOString().split("T")[0];
          payroll.push({ "id": data._id, "from": formattedDateFrom, "to": formattedDateTo })
        })
        setPayrolls(payroll)
        setOpenPayslipV2(true)
      }
      else {
        setPayrolls([])
        setOpenPayslipV2(true)
      }
      setLoading(false)
      setPayslipLoading(false)

    }

  }

  const handleOpenThirteenthMonthPayslip = async () => {
    let payroll = []
    if (userState._id === undefined) {
      load()
      alert("Something went wrong please try again later")
    }
    else {
      setLoading(true)
      setPayslipLoading(true)
      alert("Getting payslip data please wait")
      setUrlThirteenthMonth(`https://payroll.sparkletimekeeping.com/13thmonthpayslip/${userState._id}`)
      setOpenThirteenMonthPayslip(true)
      setLoading(false)
      setPayslipLoading(false)

    }

  }

  const handleClosePayslip = async () => {
    setOpenPayslip(false)
    setActiveUsers([])
    setUrlPayslip('')
    setIsPress({
      history: false,
      schedule: false,
      payslip: false,
      video: false,
      settings: false
    })
  }

  const handleCloseThirteenMonthPayslip = async () => {
    setOpenThirteenMonthPayslip(false)
    setActiveUsers([])
    setUrlThirteenthMonth('')
    setIsPress({
      history: false,
      schedule: false,
      payslip: false,
      video: false,
      settings: false
    })
  }

  const handleClosePayslipV2 = async () => {
    setOpenPayslipV2(false)
    setActiveUsers([])
    setUrlPayslip('')
    setIsPress({
      history: false,
      schedule: false,
      payslip: false,
      video: false,
      settings: false
    })
  }
  // Remove the historyEvents import
  // import { historyEvents } from '../../pages/EmployeeDashboard';

  const handleChangeDate = async (date) => {
    const fomattedDate = moment(date).format('YYYY-MM-DD')
    setStartDate(date)
    const result = await user_api.get_users_bydate(userState._id, fomattedDate)
    setUsers(result.data)
  }

  const [historyLoading, setHistoryLoading] = useState(false)
  const [scheduleLoading, setScheduleLoading] = useState(false)
  const [payslipLoading, setPayslipLoading] = useState(false)
  const [scheduleCache, setScheduleCache] = useState({})
  const [schedulePage, setSchedulePage] = useState(1)
  const [scheduleTotalPages, setScheduleTotalPages] = useState(1)
  const [hasMoreSchedules, setHasMoreSchedules] = useState(true)
  const [isViewingSpecificDate, setIsViewingSpecificDate] = useState(false)
  const ITEMS_PER_PAGE = 10
  const [openBreaklistEmailDialog, setOpenBreaklistEmailDialog] = useState(false);
  const [useAlternativeEmail, setUseAlternativeEmail] = useState(false);
  const [alternativeEmail, setAlternativeEmail] = useState('');

  useEffect(() => {
    if (userState) {
        setUseAlternativeEmail(userState.useAlternativeBreaklistEmail || false);
        setAlternativeEmail(userState.alternativeBreaklistEmail || '');
    }
  }, [userState]);
  
  const handleOpenSchedule = async () => {
    if (userState._id === undefined) {
      load()
      alert("Something went wrong please try again later")
    }
    else {
      // Show loading animation before any operations
      setScheduleLoading(true)
      setUserGetSchedule([]) // Clear previous data to show loading state
      
      // Reset pagination when opening schedule view
      setSchedulePage(1)
      setHasMoreSchedules(true)
      setIsViewingSpecificDate(false)
      
      // Store the current date before resetting it
      const previousDate = scheduleDate
      
      // Reset date picker value - this allows selecting the same date again
      setScheduleDate(null)
      
      // Reset the UI after a small delay to avoid confusion
      setTimeout(() => {
        setScheduleDate(new Date())
      }, 100)
      
      // Open dialog early to show loading animation
      setOpenSchedule(true)
      
      // Always fetch fresh data instead of using cache
      try {
        const result = await user_api.get_schedule(userState._id)
        if (result.data.length <= 0) {
          alert("No schedule found")
          setUserGetSchedule([])
        } else {
          // Store in cache and display first page
          setScheduleCache({...scheduleCache, all: result.data})
          setUserGetSchedule(result.data.slice(0, ITEMS_PER_PAGE))
          setScheduleTotalPages(Math.ceil(result.data.length / ITEMS_PER_PAGE))
        }
      } catch (error) {
        console.error("Error fetching schedules:", error)
        alert("Failed to load schedules. Please try again.")
      } finally {
        setScheduleLoading(false)
      }
    }
  }

  const handleChangeScheduleDate = async (date) => {
    const formattedDate = moment(date).format('YYYY-MM-DD')
    setScheduleDate(date)
    setIsViewingSpecificDate(true)
    
    // Clear previous data to show loading state
    setUserGetSchedule([])
    
    // Always fetch fresh data for the selected date
    setScheduleLoading(true)
    try {
      const data = {
        id: userState._id,
        date: moment(addDays(date, 0)).format('YYYY-MM-DD'),
      }
      const result = await user_api.get_specific_schedule_with_date_v2(data)
      // Update cache and state
      setScheduleCache({...scheduleCache, [`date_${formattedDate}`]: result.data})
      setUserGetSchedule(result.data)
    } catch (error) {
      console.error("Error fetching schedule for date:", error)
    } finally {
      setScheduleLoading(false)
    }
  }

  const loadMoreSchedules = async () => {
    if (!hasMoreSchedules || !scheduleCache.all) return
    
    setScheduleLoading(true)
    
    try {
      // Check if we need to fetch more data from the server
      const nextPage = schedulePage + 1
      const startIndex = (nextPage - 1) * ITEMS_PER_PAGE
      const endIndex = startIndex + ITEMS_PER_PAGE
      
      if (startIndex < scheduleCache.all.length) {
        const currentItems = userGetSchedule
        const newItems = scheduleCache.all.slice(startIndex, endIndex)
        setUserGetSchedule([...currentItems, ...newItems])
        setSchedulePage(nextPage)
        
        // Check if we've reached the end
        if (endIndex >= scheduleCache.all.length) {
          setHasMoreSchedules(false)
        }
      } else {
        setHasMoreSchedules(false)
      }
    } catch (error) {
      console.error("Error loading more schedules:", error)
    } finally {
      setScheduleLoading(false)
    }
  }

  const handleUpdateEmail = async () => {
    try {
      setSubmitting(true);
       const records = {
        "id": userState._id,
        "email": newEmail
      };
      const result = await useUser.update_email(records);
      if(result.status === 200) {
        // Log successful email update
        logSuccessAction({
          user: userState._id,
          company: userState.company,
          userDisplay: {
            name: userState.displayName,
            email: userState.email
          },
          role: userState.role,
          action: 'Update Email Address',
          category: ACTION_CATEGORIES.ACCOUNT_MANAGEMENT,
          details: `Successfully updated email address from "${userState.email}" to "${newEmail}". User will need to re-login with new email.`
        });
        
        alert("Email successfuly updated please relogin using your new email")
        await storage.remove()
        navigate(`/login`)
      }
      else {
        alert(result.data.msg)
      }
    } catch (error) {
      console.error("An error occurred:", error);
    } finally {
      setSubmitting(false);
    }
  }

  const exportStoresToExcel = (storesList) => {
    // Convert array of strings to array of objects for Excel
    const formattedData = storesList.map(name => ({ 'Store Name': name }));

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Stores');

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    const data = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    saveAs(data, 'StoresList.xlsx');
  };

  const handleAuthUpdateEmail = async () => {
    try {
      setSubmitting(true);
       const data = {
        email: userState.email,
        pass: authCheckPass
      }

      const result = await authUser.authenticate_check(data);
      if(result.data.success) {
        handleUpdateEmail()
        return
      }
      alert("Failed to authorize")
    } catch (error) {
      console.error("An error occurred:", error);
      alert("Something wrong happened, try again later")
    } finally {
      setSubmitting(false);
    }
  }

  const handleAuthUpdateCompany = async () => {
    try {
      setSubmitting(true);
       const data = {
        email: userState.email,
        pass: authCheckPassCompany
      }

      const result = await authUser.authenticate_check(data);
      if(result.data.success) {
        setAuthCheckEditCompany(false)
        return
      }
      alert("Failed to authorize")
    } catch (error) {
      console.error("An error occurred:", error);
      alert("Something wrong happened, try again later")
    } finally {
      setSubmitting(false);
    }
  }

  const handleCloseSchedule = async () => {
    setOpenSchedule(false)
    setIsPress({
      history: false,
      schedule: false,
      payslip: false,
      video: false,
      settings: false
    })
  }

  const handleisPressButton = (data) => {
    const tabs = ['history', 'schedule', 'payslip', 'video', 'settings'];

    setIsPress(
      tabs.reduce((acc, tab) => ({ ...acc, [tab]: tab === data }), {})
    );
  }

  const handleSwitchPage = (data) => {
    if (data === 0) {
      setSummaryPage(true)
      setAllShiftPage(false)
    } else {
      setSummaryPage(false)
      setAllShiftPage(true)
    }
  }

  const handleNavigate = (page) => {
    switch (page) {
      case 'profile':
        onNavigate()
        navigate('app/profile')
        break;
      case 'my-company':
        onNavigate()
        navigate('app/my-company')
        break;
      case 'history':
        onNavigate()
        navigate('/dashboard/app/my-history');
        break;
      case 'schedule':
        handleOpenSchedule();
        handleisPressButton("schedule");
        break;
      case 'payslip':
        handleOpenPayslip();
        handleisPressButton("payslip");
        break;
      case 'video':
        handleOpenVideoGuides();
        handleisPressButton("video");
        break;
      case 'required-documents':
        onNavigate()
        navigate('app/required-documents')
        break;
      default:
        break;
    }
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

  const isEmailValid = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleSaveBreaklistEmailSettings = async () => {
    setSubmitting(true);
    try {
        const data = {
            id: userState._id,
            useAlternativeBreaklistEmail: useAlternativeEmail,
            alternativeBreaklistEmail: useAlternativeEmail ? alternativeEmail : ''
        };
        const result = await user_api.updateBreaklistEmailSettings(data);
        if (result.status === 200) {
            // Log successful breaklist email settings update
            logSuccessAction({
              user: userState._id,
              company: userState.company,
              userDisplay: {
                name: userState.displayName,
                email: userState.email
              },
              role: userState.role,
              action: 'Update Breaklist Email Settings',
              category: ACTION_CATEGORIES.ACCOUNT_MANAGEMENT,
              details: `Successfully updated breaklist email settings. Alternative email ${useAlternativeEmail ? 'enabled' : 'disabled'}${useAlternativeEmail ? ` (${alternativeEmail})` : '. Primary email will be used'}.`
            });
            
            enqueueSnackbar('Settings saved successfully', { variant: 'success' });
            setOpenBreaklistEmailDialog(false);
            await load();
        } else {
            enqueueSnackbar(result.data.msg || 'Failed to save settings', { variant: 'error' });
        }
    } catch (error) {
        enqueueSnackbar('An error occurred.', { variant: 'error' });
    } finally {
        setSubmitting(false);
    }
  };

  return (
    <>
        {
          userState.role === 4 ?
          <>
          <ListItem>
            <ListItemButton onClick={() => navigate('/')} sx={{display: 'flex', justifyContent: 'space-between'}}>
              <Box sx={{display: 'flex', alignItems: 'center'}}>
                <ListItemIcon>
                  <Icon icon="material-symbols:home-outline" style={{ fontSize: '1.2rem' }} />
                </ListItemIcon>
                <ListItemText primary="Home" />
              </Box>
              <ListItemIcon>
                <Icon icon="mdi-light:chevron-right" style={{ fontSize: '2rem' }} />
              </ListItemIcon>
            </ListItemButton>
          </ListItem>
          <ListItem>
            <ListItemButton onClick={() => navigate('/stores/profile')} sx={{display: 'flex', justifyContent: 'space-between'}}>
              <Box sx={{display: 'flex', alignItems: 'center'}}>
                <ListItemIcon>
                  <Icon icon="mdi:account-outline" style={{ fontSize: '1.2rem' }} />
                </ListItemIcon>
                <ListItemText primary="Profile" />
              </Box>
              <ListItemIcon>
                <Icon icon="mdi-light:chevron-right" style={{ fontSize: '2rem' }} />
              </ListItemIcon>
            </ListItemButton>
          </ListItem>
          </>
          :
          ''
        }
        {userState.role >= 3
          ?
          <>
            <ListItem>
              <ListItemButton onClick={handleClickOpenEdit} sx={{display: 'flex', justifyContent: 'space-between'}}>
                <Box sx={{display: 'flex', alignItems: 'center'}}>
                  <ListItemIcon>
                    <Icon icon="mdi:pencil" style={{ fontSize: '1.2rem' }} />
                  </ListItemIcon>
                  <ListItemText primary="Edit Company" />
                </Box>
                <ListItemIcon>
                  <Icon icon="mdi-light:chevron-right" style={{ fontSize: '2rem' }} />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
            <ListItem>
              <ListItemButton onClick={handleClickOpenUpdateEmail} sx={{display: 'flex', justifyContent: 'space-between'}}>
                <Box sx={{display: 'flex', alignItems: 'center'}}>
                  <ListItemIcon>
                    <Icon icon="mdi:email-edit" style={{ fontSize: '1.2rem' }} />
                  </ListItemIcon>
                  <ListItemText primary="Update Email" />
                </Box>
                <ListItemIcon>
                  <Icon icon="mdi-light:chevron-right" style={{ fontSize: '2rem' }} />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
            <ListItem>
              <ListItemButton onClick={handleOpenActiveUsers} sx={{display: 'flex', justifyContent: 'space-between'}}>
                <Box sx={{display: 'flex', alignItems: 'center'}}>
                  <ListItemIcon>
                    <Icon icon="mdi:account-group" style={{ fontSize: '1.2rem' }} />
                  </ListItemIcon>
                  <ListItemText primary="Generate Active Users" />
                </Box>
                <ListItemIcon>
                  <Icon icon="mdi-light:chevron-right" style={{ fontSize: '2rem' }} />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
            <ListItem hidden>
              <ListItemButton onClick={handleOpenHolidayDialog} sx={{display: 'flex', justifyContent: 'space-between'}}>
                <Box sx={{display: 'flex', alignItems: 'center'}}>
                  <ListItemIcon>
                    <Icon icon="mdi:calendar-star" style={{ fontSize: '1.2rem' }} />
                  </ListItemIcon>
                  <ListItemText primary="Set Holiday" />
                </Box>
                <ListItemIcon>
                  <Icon icon="mdi-light:chevron-right" style={{ fontSize: '2rem' }} />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>

            {/*<ListItem hidden>
              <ListItemButton onClick={handleUpdateLocation} sx={{display: 'flex', justifyContent: 'space-between'}}>
                <Box sx={{display: 'flex', alignItems: 'center'}}>
                  <ListItemIcon>
                    <Icon icon="mdi:map-marker" style={{ fontSize: '1.2rem' }} />
                  </ListItemIcon>
                  <ListItemText primary="Update Location" />
                </Box>
                <ListItemIcon>
                  <Icon icon="mdi-light:chevron-right" style={{ fontSize: '2rem' }} />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>*/}
            <ListItem>
              <ListItemButton onClick={handleOpenChecklist} sx={{display: 'flex', justifyContent: 'space-between'}}>
                <Box sx={{display: 'flex', alignItems: 'center'}}>
                  <ListItemIcon>
                    <Icon icon="mdi:clipboard-check" style={{ fontSize: '1.2rem' }} />
                  </ListItemIcon>
                  <ListItemText primary="Set Checklist" />
                </Box>
                <ListItemIcon>
                  <Icon icon="mdi-light:chevron-right" style={{ fontSize: '2rem' }} />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
            <ListItem>
              <ListItemButton
                onClick={() => exportStoresToExcel(storeListForExtraction)}
                sx={{ display: 'flex', justifyContent: 'space-between' }}
              >
                <Box sx={{display: 'flex', alignItems: 'center'}}>
                  <ListItemIcon>
                    <Icon icon="mdi:database-export" style={{ fontSize: '1.2rem' }} />
                  </ListItemIcon>
                  <ListItemText primary="Extract Stores" />
                </Box>
                <ListItemIcon>
                  <Icon icon="mdi-light:chevron-right" style={{ fontSize: '2rem' }} />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
          </>
          :
          ''
        }
        {userState.role === 0 || user.role === 0
          ?
          <List>
            <ListItem>
              <ListItemButton 
              disabled={userState.email === 'sparkletimekeepingdemo+01@gmail.com'}
              onClick={() => handleNavigate('profile')} sx={{display: 'flex', justifyContent: 'space-between'}}>
                <Box sx={{display: 'flex', alignItems: 'center'}}>
                  <ListItemIcon>
                    <Icon icon="iconamoon:profile" style={{ fontSize: '1.2rem' }} />
                  </ListItemIcon>
                  <ListItemText primary="My Profile" />
                </Box>
                <ListItemIcon>
                  <Icon icon="mdi-light:chevron-right" style={{ fontSize: '2rem' }} />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
            {(myCompany || myTraining) &&
              <>
                <ListItem>
                  <ListItemButton
                  disabled={userState.email === 'sparkletimekeepingdemo+01@gmail.com'}
                  onClick={() => handleNavigate('my-company')} sx={{display: 'flex', justifyContent: 'space-between'}}>
                    <Box sx={{display: 'flex', alignItems: 'center'}}>
                      <ListItemIcon>
                        <Icon icon="mdi:company" style={{ fontSize: '1.2rem' }} />
                      </ListItemIcon>
                      <ListItemText primary="My Company" />
                    </Box>
                    <ListItemIcon>
                      <Icon icon="mdi-light:chevron-right" style={{ fontSize: '2rem' }} />
                    </ListItemIcon>
                  </ListItemButton>
                </ListItem> 
              </>
            }
            <ListItem>
              <ListItemButton
              disabled={userState.email === 'sparkletimekeepingdemo+01@gmail.com'}
              onClick={() => handleNavigate('history')} sx={{display: 'flex', justifyContent: 'space-between'}}>
                <Box sx={{display: 'flex', alignItems: 'center'}}>
                  <ListItemIcon>
                    <Icon icon="mdi:clipboard-text-history-outline" style={{ fontSize: '1.2rem' }} />
                  </ListItemIcon>
                  <ListItemText primary="My History" />
                </Box>
                <ListItemIcon>
                  <Icon icon="mdi-light:chevron-right" style={{ fontSize: '2rem' }} />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
            <ListItem>
              <ListItemButton onClick={handleOpenSchedule} sx={{display: 'flex', justifyContent: 'space-between'}}>
                <Box sx={{display: 'flex', alignItems: 'center'}}>
                  <ListItemIcon>
                    <Icon icon="mdi:calendar-month-outline" style={{ fontSize: '1.2rem' }} />
                  </ListItemIcon>
                  <ListItemText primary="My Schedule" />
                </Box>
                <ListItemIcon>
                  <Icon icon="mdi-light:chevron-right" style={{ fontSize: '2rem' }} />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
            <ListItem>
              <ListItemButton
              disabled={userState.email === 'sparkletimekeepingdemo+01@gmail.com'}
              onClick={handleOpenPayslip} sx={{display: 'flex', justifyContent: 'space-between'}}>
                <Box sx={{display: 'flex', alignItems: 'center'}}>
                  <ListItemIcon>
                    <Icon icon="fluent:receipt-money-20-regular" style={{ fontSize: '1.2rem' }} />
                  </ListItemIcon>
                  <ListItemText primary="My Payslip" />
                </Box>
                <ListItemIcon>
                  <Icon icon="mdi-light:chevron-right" style={{ fontSize: '2rem' }} />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
            <ListItem>
              <ListItemButton 
              disabled={userState.email === 'sparkletimekeepingdemo+01@gmail.com'}
              onClick={handleOpenPayslipV2} sx={{display: 'flex', justifyContent: 'space-between'}}>
                <Box sx={{display: 'flex', alignItems: 'center'}}>
                  <ListItemIcon>
                    <Icon icon="fluent:receipt-money-20-regular" style={{ fontSize: '1.2rem' }} />
                  </ListItemIcon>
                  <ListItemText primary="My Payslip V2" />
                </Box>
                <ListItemIcon>
                  <Icon icon="mdi-light:chevron-right" style={{ fontSize: '2rem' }} />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
            <ListItem>
              <ListItemButton
              disabled={userState.email === 'sparkletimekeepingdemo+01@gmail.com'}
              onClick={handleOpenThirteenthMonthPayslip} sx={{display: 'flex', justifyContent: 'space-between'}}>
                <Box sx={{display: 'flex', alignItems: 'center'}}>
                  <ListItemIcon>
                    <Icon icon="fluent:receipt-money-20-regular" style={{ fontSize: '1.2rem' }} />
                  </ListItemIcon>
                  <ListItemText primary="Thirteenth Month Payslip" />
                </Box>
                <ListItemIcon>
                  <Icon icon="mdi-light:chevron-right" style={{ fontSize: '2rem' }} />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
            {/*<ListItem>
              <ListItemButton onClick={() => handleNavigate('my-company')} sx={{display: 'flex', justifyContent: 'space-between'}}>
                <Box sx={{display: 'flex', alignItems: 'center'}}>
                  <ListItemIcon>
                    <Icon icon="mdi:company" style={{ fontSize: '1.2rem' }} />
                  </ListItemIcon>
                  <ListItemText primary="My Company" />
                </Box>
                <ListItemIcon>
                  <Icon icon="mdi-light:chevron-right" style={{ fontSize: '2rem' }} />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>*/}
            <ListItem>
              <ListItemButton
              disabled={userState.email === 'sparkletimekeepingdemo+01@gmail.com'}
              onClick={handleOpenVideoGuides} sx={{display: 'flex', justifyContent: 'space-between'}}>
                <Box sx={{display: 'flex', alignItems: 'center'}}>
                  <ListItemIcon>
                    <Icon icon="octicon:question-24" style={{ fontSize: '1.2rem' }} />
                  </ListItemIcon>
                  <ListItemText primary="Video Guides" />
                </Box>
                <ListItemIcon>
                  <Icon icon="mdi-light:chevron-right" style={{ fontSize: '2rem' }} />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
            {myDocuments &&
            <>
                <ListItem>
                  <ListItemButton
                  disabled={userState.email === 'sparkletimekeepingdemo+01@gmail.com'}
                  onClick={() => handleNavigate('required-documents')} sx={{display: 'flex', justifyContent: 'space-between'}}>
                    <Box sx={{display: 'flex', alignItems: 'center'}}>
                      <ListItemIcon>
                        <Icon icon="mdi:file-document-outline" style={{ fontSize: '1.2rem' }} />
                      </ListItemIcon>
                      <ListItemText primary="My Documents" />
                    </Box>
                    <ListItemIcon>
                      <Icon icon="mdi-light:chevron-right" style={{ fontSize: '2rem' }} />
                    </ListItemIcon>
                  </ListItemButton>
                </ListItem>  
            </>
            }
          </List>
          :
          ''
        }
        {userState.role >= 1 ? (
          <ListItem>
            <ListItemButton onClick={() => setOpenBreaklistEmailDialog(true)} sx={{display: 'flex', justifyContent: 'space-between'}}>
              <Box sx={{display: 'flex', alignItems: 'center'}}>
                <ListItemIcon>
                  <Icon icon="mdi:email-check-outline" style={{ fontSize: '1.2rem' }} />
                </ListItemIcon>
                <ListItemText primary="Breaklist Approval Email" />
              </Box>
              <ListItemIcon>
                <Icon icon="mdi-light:chevron-right" style={{ fontSize: '2rem' }} />
              </ListItemIcon>
            </ListItemButton>
          </ListItem>
        ) : null}
        {userState.role === 1
          ?
          <>
            <ListItem>
              <ListItemButton onClick={() => navigate('/')} sx={{display: 'flex', justifyContent: 'space-between'}}>
                <Box sx={{display: 'flex', alignItems: 'center'}}>
                  <ListItemIcon>
                    <Icon icon="material-symbols:home-outline" style={{ fontSize: '1.2rem' }} />
                  </ListItemIcon>
                  <ListItemText primary="Home" />
                </Box>
                <ListItemIcon>
                  <Icon icon="mdi-light:chevron-right" style={{ fontSize: '2rem' }} />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
            <ListItem>
              <ListItemButton onClick={() => navigate('/stores/profile')} sx={{display: 'flex', justifyContent: 'space-between'}}>
                <Box sx={{display: 'flex', alignItems: 'center'}}>
                  <ListItemIcon>
                    <Icon icon="mdi:account-outline" style={{ fontSize: '1.2rem' }} />
                  </ListItemIcon>
                  <ListItemText primary="Profile" />
                </Box>
                <ListItemIcon>
                  <Icon icon="mdi-light:chevron-right" style={{ fontSize: '2rem' }} />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
            <ListItem>
              <ListItemButton onClick={handleClickOpenEdit} sx={{display: 'flex', justifyContent: 'space-between'}}>
                <Box sx={{display: 'flex', alignItems: 'center'}}>
                  <ListItemIcon>
                    <Icon icon="mdi:company" style={{ fontSize: '1.2rem' }} />
                  </ListItemIcon>
                  <ListItemText primary="Edit Company" />
                </Box>
                <ListItemIcon>
                  <Icon icon="mdi-light:chevron-right" style={{ fontSize: '2rem' }} />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
            <ListItem>
              <ListItemButton onClick={handleClickOpenUpdateEmail} sx={{display: 'flex', justifyContent: 'space-between'}}>
                <Box sx={{display: 'flex', alignItems: 'center'}}>
                  <ListItemIcon>
                    <Icon icon="mdi:email-outline" style={{ fontSize: '1.2rem' }} />
                  </ListItemIcon>
                  <ListItemText primary="Update Email" />
                </Box>
                <ListItemIcon>
                  <Icon icon="mdi-light:chevron-right" style={{ fontSize: '2rem' }} />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
            {/*<ListItem hidden>
              <ListItemButton onClick={handleUpdateLocation} sx={{display: 'flex', justifyContent: 'space-between'}}>
                <Box sx={{display: 'flex', alignItems: 'center'}}>
                  <ListItemIcon>
                    <Icon icon="mdi:map-marker-outline" style={{ fontSize: '1.2rem' }} />
                  </ListItemIcon>
                  <ListItemText primary="Update Location" />
                </Box>
                <ListItemIcon>
                  <Icon icon="mdi-light:chevron-right" style={{ fontSize: '2rem' }} />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>*/}
            <ListItem>
              <ListItemButton onClick={handleOpenChecklist} sx={{display: 'flex', justifyContent: 'space-between'}}>
                <Box sx={{display: 'flex', alignItems: 'center'}}>
                  <ListItemIcon>
                    <Icon icon="mdi:checklist" style={{ fontSize: '1.2rem' }} />
                  </ListItemIcon>
                  <ListItemText primary="Set Checklist" />
                </Box>
                <ListItemIcon>
                  <Icon icon="mdi-light:chevron-right" style={{ fontSize: '2rem' }} />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
          </>
          :
          ''
        }

        <Divider sx={{ my: 1 }} />
        <ListItem>
          <ListItemButton onClick={handleSignOut} sx={{display: 'flex', justifyContent: 'space-between'}}>
            <Box sx={{display: 'flex', alignItems: 'center'}}>
              <ListItemIcon>
                <Icon icon="mdi:logout" style={{ fontSize: '1.2rem' }} />
              </ListItemIcon>
              <ListItemText primary="Logout" />
            </Box>
            <ListItemIcon>
              <Icon icon="mdi-light:chevron-right" style={{ fontSize: '2rem' }} />
            </ListItemIcon>
          </ListItemButton>
        </ListItem>
      <Dialog open={openEdit} onClose={handleCloseEdit} disableScrollLock={true}>
        <DialogTitle>Update company</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleCloseEdit}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
            <DialogContentText>
              Kindly make sure to add the exact name of the company/store/branch from your manager. Only use this with the
              instruction of your admin.
            </DialogContentText>
          {authCheckEditCompany ? (
            <>
              <DialogContentText sx={{my: 2}}>
                Input your password to continue.
              </DialogContentText>
              <TextField
                autoFocus
                margin="dense"
                id="password"
                label="Password"
                type="password"
                fullWidth
                variant="standard"
                value={authCheckPassCompany}
                onChange={(e) => {
                  setAuthCheckPassCompany(e.target.value)
                }}
              />
              <DialogActions>
                <Button onClick={handleCloseEdit}>Cancel</Button>
                <Button onClick={handleAuthUpdateCompany} disabled={submitting}>
                  {submitting ? <CircularProgress /> : 'Next'}
                </Button>
              </DialogActions>
            </>
          ) : (
            <>
              <Formik
                initialValues={{
                  company: `${userState.company}`,
                }}
                validationSchema={validationSchema}
                onSubmit={async (data) => {
                  let result
                  if (userState.role === 4 || userState.role === 1) {
                    result = await useUser.patch_store_onboard({ ...userState, company: data.company, role: userState.role, prev: userState.company }, userState._id)
                  }
                  else {
                    result = await useUser.patch_store_onboard({ ...userState, company: data.company }, userState._id)
                  }
                  result.data.token = userState.token

                  await storage.storeUser(result.data);
                  await storage.storeToken(result.data.token)

                  if (!result.ok) {
                    Bugsnag.notify(result)
                    return enqueueSnackbar('Unable to submit your request for assitance', { variant: 'error' })
                  }
                  else {
                    await logSuccessAction({
                      user: userState._id,
                      company: data.company, // Use new company name
                      userDisplay: {
                        name: userState.displayName,
                        email: userState.email
                      },
                      role: userState.role,
                      action: 'Update Company Assignment',
                      category: ACTION_CATEGORIES.STORE_CONFIGURATION,
                      details: `Successfully updated company assignment from "${userState.company}" to "${data.company}". ${userState.role === 4 || userState.role === 1 ? 'Store manager privileges maintained.' : ''}`
                    });
                    
                    /*let params = JSON.stringify({
                      username: 'Captain Sparkle',
                      avatar_url:
                        'https://www.sparkles.com.ph/static/2629bb8535ba6ae5406fc9385dadc2e0/497c6/Spark--noodles.png',
                      content: ` Time In Log - Company update \n**from:**\n ${userState.displayName} - ${userState._id} \n**Company:**\n ${userState.company} **->** ${data.company}`,
                    })
                    await discord_api.send_message(params)*/
                    setUser({ ...userState, company: data.company })
                    handleCloseEdit()
                    return enqueueSnackbar('Company updated.', { variant: 'success' })
                  }


                }}
              >
                {({ values, handleChange, handleSubmit, isSubmitting }) => (
                  <form onSubmit={handleSubmit}>
                    <CustomTextField
                      autoFocus
                      margin="dense"
                      name="company"
                      label="Company"
                      fullWidth
                      variant="standard"
                      onChange={handleChange}
                    />

                    <DialogActions>
                      <Button onClick={handleCloseEdit}>Cancel</Button>
                      <Button type="submit" disabled={isSubmitting}>
                        {isSubmitting ? <CircularProgress /> : 'Update'}
                      </Button>
                    </DialogActions>
                  </form>
                )}
              </Formik>
            </>
          )}
        </DialogContent>
      </Dialog>
      <Dialog disableScrollLock={true} open={openSchedule} onClose={handleCloseSchedule} maxWidth="sm" classes={{ paperScrollPaper: classes.customWidth }}>
        <AppBar sx={{ position: "relative",  backgroundColor: '#2194F3', }}>
          <DialogTitle sx={{color:'white'}} >Schedule</DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleCloseSchedule}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </AppBar>
        <DialogContent>
          <Box sx={{display:'flex', justifyContent:'flex-end', paddingBottom: ".5em"}} gap={1}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DesktopDatePicker
                label="Choose Date"
                value={scheduleDate}
                minDate={new Date('2017-01-01')}
                renderInput={(params) => <TextField {...params} />}
                onChange={(date) => handleChangeScheduleDate(date)}
                sx={{flexGrow:2}}
              />
            </LocalizationProvider>
            <Button 
              onClick={handleOpenSchedule} 
              variant="contained" 
              sx={{flexGrow:1}}
              title="View all schedules"
              disabled={scheduleLoading}
            >
              {scheduleLoading ? <CircularProgress size={24} color="inherit" /> : "View All"}
            </Button>
          </Box>
          {scheduleLoading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
              <CircularProgress />
            </Box>
          ) : (
            userGetSchedule.length > 0
              ?
              <>
                {userGetSchedule.map(d => {
                  return (
                    <>
                      <br/>
                      <Box>
                        <Box
                        border={1}
                        borderRadius={2}
                        sx={{
                            overflowX: 'auto',
                            display: 'flex',
                            gap: '.5rem',
                            padding: '.5rem',
                            margin: 'auto',
                            justifyContent: 'center',
                            width: '100%'
                        }}>
                      <Box sx={{ alignContent: 'center', textAlign: 'center' }}>
                          <Typography variant='caption' >Position</Typography>
                          <br/>
                          <Typography variant="caption"  sx={{ fontSize: '.6rem' }}>{d.position}</Typography>
                      </Box>      
                      
                      <Box sx={{ alignContent: 'center', textAlign: 'center' }}>
                          <Typography variant='caption' >Start Shift</Typography>
                          <br/>
                          <Typography variant="caption"  sx={{ fontSize: '.6rem' }}>{d.from}</Typography>
                      </Box>
                      <Box sx={{ alignContent: 'center', textAlign: 'center' }}>
                          <Typography variant='caption' >End Shift</Typography>
                          <br/>
                          <Typography variant="caption"  sx={{ fontSize: '.6rem' }}>{d.to}</Typography>
                      </Box>
                      <Box sx={{ alignContent: 'center', textAlign: 'center' }}>
                          <Typography variant='caption'>Date</Typography>
                          <br/>
                          <Typography variant="caption" sx={{ fontSize: '.6rem' }}>{moment(new Date(d.date)).format('MMMM-DD-YYYY')}</Typography>   
                      </Box>
                  </Box>
              </Box>
                    </>
                  )
                })}
                {/* Only show "Load More" button when viewing all schedules, not for a specific date */}
                {hasMoreSchedules && scheduleCache.all && schedulePage < scheduleTotalPages && !isViewingSpecificDate && (
                  <Box sx={{display: 'flex', justifyContent: 'center', mt: 2}}>
                    <Button 
                      onClick={loadMoreSchedules} 
                      variant="outlined" 
                      startIcon={scheduleLoading ? <CircularProgress size={16} /> : <Icon icon="mdi:chevron-down" />}
                      disabled={scheduleLoading}
                    >
                      {scheduleLoading ? "Loading..." : "Load More"}
                    </Button>
                  </Box>
                )}
              </>
              :
              ''
          )}
        </DialogContent>
      </Dialog>
      {/* <Dialog open={coc} onClose={handleCloseCoC} fullWidth disableScrollLock={true}>
        <DialogTitle>Update CoC?</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleCloseCoC}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <DialogContentText>
            Paste the upload link of COC.
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="link"
            label="Link"
            type="text"
            fullWidth
            variant="standard"
            onChange={(e) => setLink(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseCoC}>Cancel</Button>
          <Button type="button" onClick={handleUpdateCoc}>
            {isLoading ? <CircularProgress /> : 'Update'}
          </Button>
        </DialogActions>
      </Dialog> */}
      <Modal
        disableScrollLock={true}
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        open={openPayslip}
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={openPayslip}>
          <Box sx={urlPayslip ? {...style, height: '90%', width: '90%'} : {...style}}>
            <Grid container sx={urlPayslip ? { pl: 2, height:'100%', width: '100%', overflow: (checkIOS || checkMac) ? 'auto' : 'hidden'} : { pl: 2 }} >
              <Typography variant="h4" style={{ color: '#000', margin: "0px 0px 17px 0px" }}>
                Available Payslip
              </Typography>
              <FormControl fullWidth variant="outlined">
                <InputLabel id="cutoff-label">Select Cutoff</InputLabel>
                <Select
                  labelId="cutoff-label"
                  id="cutoff-select"
                  value={selectedPayroll}
                  onChange={handlePayrollChange}
                  input={<OutlinedInput label="Select Cutoff" />} // ✅ fixes overlap
                >
                  {payrolls.length > 0 ? (
                    payrolls.map((data) => (
                      <MenuItem key={data.id} value={data.id}>
                        <b>{data.from}</b> - to - <b>{data.to}</b>
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>No Available Payslip</MenuItem>
                  )}
                </Select>
              </FormControl>
              {activeUserLoading || isLoading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '200px' }}>
                  <CircularProgress />
                </Box>
              ) : (
                urlPayslip && (
                  <Box sx={{ my: 2, overflow: 'hidden', width: '100%', height: (checkIOS || checkMac) ? '60%' : '65%' }}>
                    {!checkAndroid ? (
                      <iframe
                          src={urlPayslip}
                          className="responsive-iframe"
                          style={{ width: '100%', height: '100%', border: 'none' }}
                        >
                      </iframe>
                    ) : (
                      <iframe src={`https://docs.google.com/gview?url=${urlPayslip}&embedded=true`} width="100%" height="100%" style={{ zoom: '100%' }}></iframe>
                    )}
                  </Box>
                )
              )}
              {(checkIOS || checkMac) && urlPayslip && (
                <Alert severity="info">{checkMac ? 'Hover over the payslip bottom center and click the download icon to save' : 'To save, Press and hold for 2 seconds on the payslip and click "Save to photos"'}</Alert>
              )}
              <Box sx={{ mt: 1, display: 'flex', width: '100%', justifyContent: 'space-between' }}>
                <Button variant="contained" color="primary" onClick={handleClosePayslip} sx={{ flex: 1, mr: 1 }}>
                  Back
                </Button>
                {checkAndroid && (
                  <Button variant="contained" color="success" onClick={saveGeneratedPayslip} sx={{ flex: 1, ml: 1 }}>
                    Save
                  </Button>
                )}
              </Box>
              
            </Grid>
          </Box>
        </Fade>
      </Modal>

      <Modal
        disableScrollLock={true}
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        open={openPayslipV2}
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={openPayslipV2}>
          <Box sx={urlPayslipV2 ? {...style, height: '90%', width: '90%'} : {...style}}>
            <Grid container sx={urlPayslipV2 ? { pl: 2, height:'100%', width: '100%', overflow: (checkIOS || checkMac) ? 'auto' : 'hidden'} : { pl: 2 }} >
              <Typography variant="h4" style={{ color: '#000', margin: "0px 0px 17px 0px" }}>
                Available Payslip
              </Typography>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select Cutoff</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={selectedPayrollV2}
                  onChange={handlePayrollChangeV2}
                  fullWidth
                >
                  {payrolls.length > 0 ? (
                    payrolls.map((data, index) => (
                      <MenuItem key={index} value={data.id}>
                        <b>{data.from}</b> - to - <b>{data.to}</b>
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>No Available Payslip</MenuItem>
                  )}
                </Select>
              </FormControl>
              {activeUserLoading || isLoading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '200px' }}>
                  <CircularProgress />
                </Box>
              ) : (
                urlPayslipV2 && (
                  <Box sx={{ my: 2, overflow: 'hidden', width: '100%', height: (checkIOS || checkMac) ? '60%' : '65%' }}>
                    <iframe
                      src={urlPayslipV2}
                      style={{
                        width: '200%',
                        height: '200%',
                        border: 'none',
                        transform: 'scale(0.45)',
                        transformOrigin: '0 0'
                      }}
                    ></iframe>
                  </Box>
                )
              )}
              {(checkIOS || checkMac) && urlPayslip && (
                <Alert severity="info">{checkMac ? 'Hover over the payslip bottom center and click the download icon to save' : 'To save, Press and hold for 2 seconds on the payslip and click "Save to photos"'}</Alert>
              )}
              <Box sx={{ mt: 1, display: 'flex', width: '100%', justifyContent: 'space-between' }}>
                <Button variant="contained" color="primary" onClick={handleClosePayslipV2} sx={{ flex: 1, mr: 1 }}>
                  Back
                </Button>
                {checkAndroid && (
                  <Button variant="contained" color="success" onClick={saveGeneratedPayslip} sx={{ flex: 1, ml: 1 }}>
                    Save
                  </Button>
                )}
              </Box>
              
            </Grid>
          </Box>
        </Fade>
      </Modal>

      <Modal
        disableScrollLock={true}
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        open={openThirteenMonthPayslip}
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={openThirteenMonthPayslip}>
          <Box sx={urlThirteenthMonth ? {...style, height: '90%', width: '90%'} : {...style}}>
            <Grid container sx={urlThirteenthMonth ? { pl: 2, height:'100%', width: '100%', overflow: (checkIOS || checkMac) ? 'auto' : 'hidden'} : { pl: 2 }} >
              <Box sx={{ my: 2, overflow: 'hidden', width: '100%', height: (checkIOS || checkMac) ? '60%' : '70%' }}>
                <iframe
                  src={urlThirteenthMonth}
                  style={{
                    width: '200%',
                    height: '200%',
                    border: 'none',
                    transform: 'scale(0.45)',
                    transformOrigin: '0 0'
                  }}
                ></iframe>
              </Box>
              {(checkIOS || checkMac) && urlThirteenthMonth && (
                <Alert severity="info">{checkMac ? 'Hover over the payslip bottom center and click the download icon to save' : 'To save, Press and hold for 2 seconds on the payslip and click "Save to photos"'}</Alert>
              )}
              <Box sx={{ mt: 1, display: 'flex', width: '100%', justifyContent: 'space-between' }}>
                <Button variant="contained" color="primary" onClick={handleCloseThirteenMonthPayslip} sx={{ flex: 1, mr: 1 }}>
                  Back
                </Button>
                {checkAndroid && (
                  <Button variant="contained" color="success" onClick={saveGeneratedPayslip} sx={{ flex: 1, ml: 1 }}>
                    Save
                  </Button>
                )}
              </Box>
              
            </Grid>
          </Box>
        </Fade>
      </Modal>

      <Modal
        disableScrollLock={true}
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        open={openActiveUsers}
        onClose={handleCloseActiveUsers}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={openActiveUsers}>
          <Box sx={style}>
            <Grid container sx={{ pl: 2 }} >
              <Typography variant="h4" style={{ color: '#000', margin: "0px 0px 17px 0px" }}>
                Get Active Users
              </Typography>
              <IconButton
                aria-label="close"
                onClick={handleCloseActiveUsers}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
              <FormControl fullWidth style={{ margin: "0px 0px 17px 0px" }}>
                <InputLabel id="demo-simple-select-label">Select company</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={selectedCompany}
                  label="Select month"
                  onChange={handleCompanyChange}
                >
                  {company.map((company, index) => (
                    <MenuItem value={company}>{company}</MenuItem>
                  ))}

                </Select>
              </FormControl>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select month</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={selectedMonth}
                  label="Select month"
                  onChange={handleMonthChange}
                >
                  {months.map((month, index) => (
                    <MenuItem value={index}>{month}</MenuItem>
                  ))}

                </Select>
              </FormControl>
              {activeUsers.length > 0
                ?
                <CSVLink
                  filename={`Active users for ${selectedCompany} - ${months[selectedMonth]}.csv`}
                  data={getCsvData()}
                  style={{
                    display: 'flex',
                    width: '100%',
                    margin: '17px 0px 0px 100px'
                  }}
                >
                  <GetAppIcon sx={{ mr: 1 }} /> <Typography variant="p">Export</Typography>
                </CSVLink>
                :
                <Button variant="contained" color="success" onClick={handleExtractUsers} sx={{ mt: 2, px: 17 }} >
                  {activeUserLoading ? <CircularProgress size={35} style={{ width: '100px' }} color="inherit" /> : 'Export'}
                </Button>
              }

            </Grid>
          </Box>
        </Fade>
      </Modal>
      <Modal
        disableScrollLock={true}
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        open={openChecklist}
        onClose={handleCloseChecklist}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >

        <Fade in={openChecklist}>
          <Box sx={style}>
            <Grid container sx={{ pl: 2 }} >
              <Typography variant="h4" style={{ color: '#000', margin: "0px 0px 17px 0px" }}>
                Checklists
              </Typography>
              <IconButton
                aria-label="close"
                onClick={handleCloseChecklist}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
              <FormControl fullWidth>
                <FormControlLabel sx={{mb: 3}}
                  control={
                    <Checkbox
                      checked={checklistStatus}
                      onChange={(e) => setChecklistStatus(e.target.checked)}
                      color="primary"

                    />
                  }
                  label="Enable Checklists" // Text next to the checkbox
                />
                {checklists.length > 0 ?
                  checklists.map((checklist, key) => (
                    <React.Fragment key={key}>
                        <TextField
                            id="outlined-controlled"
                            label={"Checklist" + (key + 1)}
                            value={checklist}
                            onChange={(e) => {
                                const updatedChecklists = [...checklists];
                                updatedChecklists[key] = e.target.value;
                                setChecklists(updatedChecklists);
                            }}
                        />
                        <br/>
                    </React.Fragment>   
                  ))
                  : null
                }
              </FormControl>
              <Button variant="contained" color="success" onClick={handleSubmitChecklist} sx={{ mt: 2, px: 17 }} >
                {activeUserLoading ? <CircularProgress size={35} style={{ width: '100px' }} color="inherit" /> : 'Submit'}
              </Button>
            </Grid>
          </Box>
        </Fade>
      </Modal>
      <Dialog 
        disableScrollLock={true}
        open={openVideoGuides} 
        onClose={handleCloseVideoGuides} 
        fullWidth
      >
        <DialogTitle>Video Guideline </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleCloseVideoGuides}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent sx={{padding: '30px 15px', height:'50vh'}}>
          {videoFetched? videoList && videoList.map((data) =>(
            <Box sx={{
              display:'flex', 
              justifyContent:'space-between',
              alignItems:'center',
              padding: '16px', // Add padding for better spacing
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Add a subtle box shadow for a paper effect
              borderRadius: '8px', // Optional: Add border-radius for rounded corners
            }}>
                <Box>
                <Typography style={{ marginBottom: '-1px', fontSize:'10px', fontWeight:'bold' }}> {data.title}</Typography>
                <Typography style={{fontSize:'10px' }}> {data.description} </Typography>
              </Box>
              <Box sx={{height:'1vh'}}>
                <Button variant='contained' size='small' onClick={() => handleViewYoutube(data.youtubeId)}>
                  <Typography color="white" variant='caption'> Watch </Typography>
                </Button>
              </Box>
            </Box>
          )): ''}
          <Box sx={{
            display:'flex', 
            justifyContent:'space-between',
            alignItems:'center',
            padding: '16px', // Add padding for better spacing
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Add a subtle box shadow for a paper effect
            borderRadius: '8px', // Optional: Add border-radius for rounded corners
          }}>
              <Box>
              <Typography style={{ marginBottom: '-1px', fontSize:'10px', fontWeight:'bold' }}> Location Tutorial (IOS) </Typography>
              <Typography style={{fontSize:'10px' }}> IOS Location tutorial </Typography>
            </Box>
            <Box sx={{height:'1vh'}}>
              <Button variant='contained' size='small' onClick={() => handleViewYoutube("bxKNDaG-J9Q")}>
                <Typography color="white" variant='caption'> Watch </Typography>
              </Button>
            </Box>
          </Box>
          <Box sx={{
            display:'flex', 
            justifyContent:'space-between',
            alignItems:'center',
            padding: '16px', // Add padding for better spacing
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Add a subtle box shadow for a paper effect
            borderRadius: '8px', // Optional: Add border-radius for rounded corners
          }}>
              <Box>
              <Typography style={{ marginBottom: '-1px', fontSize:'10px', fontWeight:'bold' }}> Location Tutorial (Android) </Typography>
              <Typography style={{fontSize:'10px' }}> Android Location tutorial </Typography>
            </Box>
            <Box sx={{height:'1vh'}}>
              <Button variant='contained' size='small' onClick={() => handleViewYoutube("xxN16yFainM")}>
                <Typography color="white" variant='caption'> Watch </Typography>
              </Button>
            </Box>
          </Box>
          <Box sx={{
            display:'flex', 
            justifyContent:'space-between',
            alignItems:'center',
            padding: '16px', // Add padding for better spacing
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Add a subtle box shadow for a paper effect
            borderRadius: '8px', // Optional: Add border-radius for rounded corners
          }}>
              <Box>
              <Typography style={{ marginBottom: '-1px', fontSize:'10px', fontWeight:'bold' }}> Onboarding </Typography>
              <Typography style={{fontSize:'10px' }}> Onboarding tutorial </Typography>
            </Box>
            <Box sx={{height:'1vh'}}>
              <Button variant='contained' size='small' onClick={() => handleViewYoutube("AtGwDkSdrhs")}>
                <Typography color="white" variant='caption'> Watch </Typography>
              </Button>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
      <Modal
        disableScrollLock={true}
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        open={openUpdateEmail}
        onClose={handleCloseUpdateEmail}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >

        <Fade in={openUpdateEmail}>
          <Box sx={style}>
            <Grid container sx={{ pl: 2 }} >
              <Typography variant="h4" style={{ color: '#000', margin: "0px 0px 17px 0px" }}>
                { authCheck ? 'Enter your password' : 'Update Email'}
              </Typography>
              <IconButton
                aria-label="close"
                onClick={ authCheck ? () => setAuthCheck(false) : () => handleCloseUpdateEmail()}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
              {
                authCheck ? (
                <>
                <FormControl fullWidth>
                    <TextField
                        id="outlined-controlled"
                        label={"Enter your password"}
                        type="password"
                        value={authCheckPass}
                        onChange={(e) => {
                          setAuthCheckPass(e.target.value);
                        }}
                    />
                    <br/>
                </FormControl>
                </>
                ) : (
                  <FormControl fullWidth>
                    <React.Fragment key={userState._id}>
                        <TextField
                            id="outlined-controlled"
                            label={"Enter new email"}
                            value={newEmail}
                            onChange={(e) => {
                              setNewEmail(e.target.value);
                            }}
                        />
                        <br/>
                    </React.Fragment>   
                  </FormControl>
                )
              }
              
              <Button variant="contained" color="success" onClick={ authCheck ? () => handleAuthUpdateEmail() : () => setAuthCheck(true)} sx={{ mt: 2, px: 17 }} >
                {submitting ? <CircularProgress size={35} style={{ width: '100px' }} color="inherit" /> : 'Submit'}
              </Button>
            </Grid>
          </Box>
        </Fade>
      </Modal>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={historyLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={scheduleLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={payslipLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <MyHistoryDialog 
        open={openHistory} 
        onClose={handleCloseHistory} 
        userId={userState._id} 
      />

      <Dialog open={openBreaklistEmailDialog} onClose={() => setOpenBreaklistEmailDialog(false)} fullWidth>
        <DialogTitle>Breaklist Approval Email</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={() => setOpenBreaklistEmailDialog(false)}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <DialogContentText sx={{mb: 2}}>
            Use an alternative email for breaklist approval notifications. If toggled off, your primary account email ({userState.email}) will be used.
          </DialogContentText>
          <FormControlLabel
              control={
                  <Checkbox
                      checked={useAlternativeEmail}
                      onChange={(e) => setUseAlternativeEmail(e.target.checked)}
                  />
              }
              label="Use alternative email address"
          />
          {useAlternativeEmail && (
              <TextField
                  autoFocus
                  margin="dense"
                  label="Alternative Email Address"
                  type="email"
                  fullWidth
                  variant="standard"
                  value={alternativeEmail}
                  onChange={(e) => setAlternativeEmail(e.target.value)}
                  placeholder="Enter the alternative email"
                  error={useAlternativeEmail && alternativeEmail.length > 0 && !isEmailValid(alternativeEmail)}
                  helperText={
                    useAlternativeEmail && alternativeEmail.length > 0 && !isEmailValid(alternativeEmail)
                      ? 'Please enter a valid email address.'
                      : ''
                  }
              />
          )}
        </DialogContent>
        <DialogActions>
            <Button onClick={() => setOpenBreaklistEmailDialog(false)}>Cancel</Button>
            <Button onClick={handleSaveBreaklistEmailSettings} disabled={submitting || (useAlternativeEmail && !isEmailValid(alternativeEmail))} variant="contained">
              {submitting ? <CircularProgress size={24} /> : 'Save'}
            </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openSetHoliday}
        onClose={() => setOpenSetHoliday(false)}
        fullWidth
        maxWidth="md"
        PaperProps={{
          sx: {
            borderRadius: 2,
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
          }
        }}
      >
        <DialogTitle sx={{
          backgroundColor: '#f5f5f5',
          color: '#333',
          fontWeight: 600,
          py: 3,
          px: 3
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Icon icon="mdi:calendar-star" style={{ fontSize: '1.5rem' }} />
            Set Holiday
          </Box>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={() => setOpenSetHoliday(false)}
          sx={{
            position: 'absolute',
            right: 16,
            top: 16,
            color: (theme) => theme.palette.grey[500],
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.9)',
            }
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent sx={{ p: 3, pt: 2 }}>
          {holidayDialogLoading ? (
            <Box sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '200px',
              flexDirection: 'column',
              gap: 2
            }}>
              <CircularProgress />
              <Typography variant="body1" color="text.secondary">
                Loading groups and stores...
              </Typography>
            </Box>
          ) : (
            <>
              <Box sx={{ mb: 3 }}>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                  Create a new holiday that will be applied to selected groups and/or stores.
                </Typography>
              </Box>

          {/* Holiday Details Section */}
          <Box sx={{
            backgroundColor: '#f8f9fa',
            p: 3,
            borderRadius: 2,
            mb: 3,
            border: '1px solid #e9ecef'
          }}>
            <Typography variant="h6" sx={{ mb: 2, color: '#495057', fontWeight: 600 }}>
              Holiday Details
            </Typography>

            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <TextField
                  label="Holiday Name"
                  fullWidth
                  value={holidayName}
                  onChange={(e) => setHolidayName(e.target.value)}
                  placeholder="e.g., Christmas Day"
                  variant="outlined"
                  required
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  label="Holiday Date"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  value={holidayDate}
                  onChange={(e) => setHolidayDate(e.target.value)}
                  variant="outlined"
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth variant="outlined">
                  <InputLabel>Holiday Type</InputLabel>
                  <Select
                    value={holidayType}
                    label="Holiday Type"
                    onChange={(e) => setHolidayType(e.target.value)}
                  >
                    <MenuItem value="Legal Holiday">Legal Holiday</MenuItem>
                    <MenuItem value="Special Holiday">Special Holiday</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>

          {/* Selection Section */}
          <Box sx={{
            backgroundColor: '#f8f9fa',
            p: 3,
            borderRadius: 2,
            border: '1px solid #e9ecef'
          }}>
            <Typography variant="h6" sx={{ mb: 2, color: '#495057', fontWeight: 600 }}>
              Apply to Groups & Stores
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              Select the groups and stores where this holiday should be applied. You can select multiple items.
            </Typography>

            {/* Toggle for application scope */}
            <Box sx={{ mb: 3 }}>
              <FormControlLabel
                control={
                  <Switch
                    checked={applyToWholeGroups}
                    onChange={(e) => setApplyToWholeGroups(e.target.checked)}
                    color="primary"
                  />
                }
                label={
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    Apply to entire selected groups only
                  </Typography>
                }
              />
              <Typography variant="body2" color="text.secondary" sx={{ ml: 4 }}>
                {applyToWholeGroups
                  ? "Holiday will be applied to all stores within the selected groups."
                  : "Holiday will be applied BOTH to the specific stores you select below and to the entire selected groups. Remove the group/s if you want to apply to specific stores only."
                }
              </Typography>
            </Box>

            <Grid container spacing={3}>
              <Grid item xs={12} md={applyToWholeGroups ? 12 : 6}>
                <Autocomplete
                  multiple
                  disableCloseOnSelect
                  options={groupList}
                  getOptionLabel={(option) => option.companyName}
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                  value={selectedGroups}
                  onChange={handleGroupChange}
                  renderOption={(props, option) => (
                    <Box component="li" {...props}>
                      <Checkbox
                        style={{ marginRight: 8 }}
                        checked={props['aria-selected']}
                        color="primary"
                      />
                      {option.companyName}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Select Groups"
                      placeholder="Choose groups..."
                    />
                  )}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        variant="outlined"
                        label={option.companyName}
                        {...getTagProps({ index })}
                        sx={{
                          backgroundColor: '#e3f2fd',
                          color: '#1976d2',
                          borderColor: '#1976d2'
                        }}
                      />
                    ))
                  }
                  sx={{ mb: 2 }}
                />
              </Grid>
              {!applyToWholeGroups && (
                <Grid item xs={12} md={6}>
                  <Autocomplete
                    multiple
                    disableCloseOnSelect
                    options={storeList}
                    getOptionLabel={(option) => option}
                    value={selectedStores}
                    onChange={(event, newValue) => setSelectedStores(newValue)}
                    renderOption={(props, option) => (
                      <Box component="li" {...props}>
                        <Checkbox
                          style={{ marginRight: 8 }}
                          checked={props['aria-selected']}
                          color="primary"
                        />
                        {option}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Select Specific Stores"
                        placeholder="Choose stores..."
                      />
                    )}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => (
                        <Chip
                          variant="outlined"
                          label={option}
                          {...getTagProps({ index })}
                          sx={{
                            backgroundColor: '#e8f5e8',
                            color: '#2e7d32',
                            borderColor: '#2e7d32'
                          }}
                        />
                      ))
                    }
                    sx={{ mb: 2 }}
                  />
                </Grid>
              )}
            </Grid>

            {/* Selection Summary */}
            {selectedGroups.length > 0 && (
              <Box sx={{
                mt: 2,
                p: 2,
                backgroundColor: applyToWholeGroups ? '#e8f5e8' : '#fff3e0',
                borderRadius: 1,
                border: `1px solid ${applyToWholeGroups ? '#4caf50' : '#ffcc02'}`
              }}>
                <Typography variant="body2" sx={{ fontWeight: 500, color: applyToWholeGroups ? '#2e7d32' : '#e65100', mb: 1 }}>
                  Selection Summary:
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  <span>Groups: {selectedGroups.map(g => g.companyName).join(', ')}</span>
                  {applyToWholeGroups ? (
                    <span> (will apply to all stores in these groups)</span>
                  ) : (
                    <>
                      {selectedStores.length > 0 ? (
                        <>
                          <br />
                          <span style={{ fontSize: '0.875rem', color: '#666' }}>
                            Other stores in the selected groups will NOT observe this holiday.
                          </span>
                        </>
                      ) : (
                        <>
                          <br />
                          <span style={{ color: '#f44336', fontWeight: 500 }}>⚠ No stores selected - please select specific stores</span>
                        </>
                      )}
                    </>
                  )}
                </Typography>
              </Box>
            )}
          </Box>
            </>
          )}
        </DialogContent>

        <DialogActions sx={{
          p: 3,
          pt: 2,
          backgroundColor: '#f5f5f5',
          justifyContent: 'space-between'
        }}>
          <Button
            onClick={() => setOpenSetHoliday(false)}
            variant="outlined"
            sx={{
              borderColor: '#6c757d',
              color: '#6c757d',
              '&:hover': {
                borderColor: '#5a6268',
                backgroundColor: '#e9ecef'
              }
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSaveHoliday}
            disabled={
              submitting ||
              !holidayName ||
              !holidayDate ||
              !holidayType ||
              (selectedGroups.length === 0 && selectedStores.length === 0)
            }
            variant="contained"
            sx={{
              backgroundColor: '#1976d2',
              '&:hover': {
                backgroundColor: '#1565c0'
              },
              '&:disabled': {
                backgroundColor: '#ccc',
                color: '#666'
              }
            }}
          >
            {submitting ? <CircularProgress size={24} color="inherit" /> : 'Save Holiday'}
          </Button>
        </DialogActions>
      </Dialog>

    </>
  )
}

export default AccountPopover;